module.exports = __webpack_public_path__ + "static/media/mall_logo_main.6570251a.jpg";